import { isBlank } from '@App/common/global-validation'
import { PhoneNumberFormDefinition } from '@App/forms/common/phone-number-form'

export const formatPhoneNumber = (phoneNumberForm: PhoneNumberFormDefinition): string => {
    const { phoneCountryCode, phoneAreaCode, phoneNumber } = phoneNumberForm
    let phone = ''
    if (phoneCountryCode) {
        phone += '+' + phoneCountryCode + '-'
    }
    if (phoneAreaCode && !isBlank(phoneAreaCode)) {
        phone += phoneAreaCode.trim() + '-'
    }
    if (phoneNumber && !isBlank(phoneNumber)) {
        phone += phoneNumber.trim()
    }
    return phone
}
